import { render, staticRenderFns } from "./DepartmentRemoved.vue?vue&type=template&id=ce5f2772&scoped=true"
import script from "./DepartmentRemoved.vue?vue&type=script&lang=js"
export * from "./DepartmentRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5f2772",
  null
  
)

export default component.exports